import { Box, Container, Divider, Typography } from "@mui/material";
import React from "react";
import SwiperCore, { Autoplay, Pagination, EffectCoverflow } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import PropagateLoader from "react-spinners/PropagateLoader";
import { useAPI } from "../../../../apiContext";
SwiperCore.use([EffectCoverflow, Autoplay, Pagination]);

const AreasWeServe = () => {
	const { data } = useAPI();

	return (
		<Container sx={{ pt: 5, "& .swiper-slide": { height: "auto" } }}>
			<Box
				sx={{ border: "3px solid", borderRadius: "15px", p: 1 }}
				className='borderColor'>
				{data?._id && data?.headline?.AreasWeServe ? (
					<>
						{data?.headline?.AreasWeServe === "off" ? (
							""
						) : (
							<>
								<Typography
									className='textColor'
									sx={{ mb: 0.5, fontWeight: 900 }}
									variant='h4'
									component='div'
									gutterBottom>
									{data?.headline?.AreasWeServe}
									<Divider className={`${data?.color?.hr}`} />
								</Typography>
								{data?.areasWeServe?.length > 0 ? (
									<Swiper
										effect={"coverflow"}
										autoHeight={true}
										grabCursor={true}
										loop={true}
										autoplay={{ delay: 2500 }}
										centeredSlides={true}
										slidesPerView={"auto"}
										initialSlide={1}
										coverflowEffect={{
											rotate: 50,
											stretch: 0,
											depth: 100,
											modifier: 1,
											slideShadows: false,
										}}
										pagination={true}>
										{data?.areasWeServe?.map((a, key) => (
											<SwiperSlide
												key={key}
												style={{ position: "relative", cursor: "pointer" }}
												onClick={() => window.open(`${a?.link}`, "_blank")}>
												<img
													src={a?.imageLink2}
													alt=''
													style={{ borderRadius: 7 }}
												/>
												<Typography
													sx={{
														position: "absolute",
														top: "50%",
														left: "50%",
														transform: "translate(-50%,-50%)",
														color: "white",
														backgroundColor: "rgba(0,0,0,0.5)",
														px: 1.5,
														py: 0.5,
														borderRadius: 7,
														width: "max-content",
													}}
													variant='h6'
													component='div'
													gutterBottom>
													{a?.galleryTitle}
												</Typography>
											</SwiperSlide>
										))}
									</Swiper>
								) : (
									<Typography
										className='textColor'
										sx={{ mb: 0.5, fontWeight: 900 }}
										variant='h6'
										component='div'
										gutterBottom>
										No Photos !...
									</Typography>
								)}
							</>
						)}
					</>
				) : (
					<div className='loader'>
						<PropagateLoader size={11} />
					</div>
				)}
			</Box>
		</Container>
	);
};

export default AreasWeServe;
